export class FilePathService {
  public static getFileNameFromS3FilePath(s3FilePath: string): string {
    return s3FilePath.split('/').pop() || ''
  }

  public static encode(str: string): string {
    return btoa(encodeURI(str))
  }
}
